module.exports = __webpack_public_path__ + "img/certificate03.6798e8ae.png";